import { useCallback, useEffect, useMemo, useRef, useState } from "react";

import { debounce } from "es-toolkit";

const SEARCH_DEBOUNCE_MS = 100;

export function useDebouncedSearch(
  search: (query: string) => void,
  delayMs = SEARCH_DEBOUNCE_MS,
): [query: string, onQueryChange: (query: string) => void] {
  const [query, setQuery] = useState("");
  const searchRef = useRef(search);
  searchRef.current = search;

  const debouncedSearch = useMemo(
    () => debounce((value: string) => searchRef.current(value), delayMs),
    [delayMs],
  );

  useEffect(() => () => debouncedSearch.cancel(), [debouncedSearch]);

  const onQueryChange = useCallback(
    (value: string) => {
      setQuery(value);
      debouncedSearch(value);
    },
    [debouncedSearch],
  );

  return [query, onQueryChange];
}
